import { useNavigate } from 'react-router-dom'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { useUser } from '~/@biz_account/useUser/useUser'
import {
  getSteps,
  getActiveStepIndex,
  getExpiredIdentityActiveStepIndex,
  STEPS_EXPIRED_ANALYSIS,
  STEPS_EXPIRED_IDENTITY,
} from './steps'
import { useOnboarding } from '../useOnboarding'
import type { OnboardingStepsColorScheme } from './useOnboardingSteps'
import { BodyContent } from './BodyContent'

type Props = {
  colorScheme?: OnboardingStepsColorScheme
}

function OnboardingStepper({ colorScheme = 'light' }: Props) {
  const navigate = useNavigate()

  const { user, reloadUser } = useUser()
  const { isUserApproved } = useOnboarding(user ?? null)
  const activeStep = getActiveStepIndex(user ?? null)
  const stepsRegistration = getSteps(user ?? null)

  const hasExpiredInvestorAnalysis = user?.hasExpiredInvestorAnalysis
  const hasExpiredIdentityDocument = user?.hasExpiredIdentityDocument

  const handleUpdateRegistration = async function () {
    await reloadUser()
    navigate('/get-started')
  }

  if (isUserApproved) return null

  const isDark = colorScheme === 'dark'

  return (
    <PageContainer className="px-6 py-6 md:pt-10 bg-foreground">
      {hasExpiredIdentityDocument ? (
        <BodyContent
          title="Platnosť vášho dokladu totožnosti vypršala"
          bodyText="Pre pokračovanie v investovaní je potrebné nahrať platný doklad
								totožnosti. Kým tak neurobíte, nebude možné investovať, vkladať ani
								vyberať prostriedky. Ide o povinné overenie podľa zákonných požiadaviek."
          buttonText="Aktualizovať overenie identity"
          isDark={isDark}
          handleUpdateRegistration={handleUpdateRegistration}
          steps={STEPS_EXPIRED_IDENTITY}
          activeStep={getExpiredIdentityActiveStepIndex(user ?? null)}
          colorScheme={colorScheme}
        />
      ) : hasExpiredInvestorAnalysis ? (
        <BodyContent
          title="Platnosť vašich dotazníkov vypršala"
          bodyText="Pre pokračovanie v investovaní je potrebné opätovne vyplniť
							Investičný dotazník a Simuláciu investičného rizika. Ide o
							pravidelnú aktualizáciu podľa zákonných požiadaviek, ktorá nám
							pomáha zabezpečiť, že vaše investície zodpovedajú vašim možnostiam.
							Zaberie vám to len pár minút."
          buttonText="Vyplniť dotazník"
          isDark={isDark}
          handleUpdateRegistration={handleUpdateRegistration}
          steps={STEPS_EXPIRED_ANALYSIS}
          activeStep={0}
          colorScheme={colorScheme}
        />
      ) : (
        <BodyContent
          title="Registrácia ešte nie je dokončená"
          bodyText="Aby ste platformu mohli plnohodnotne používať, je potrebné splniť nasledujúce kroky."
          buttonText="Aktualizovať registráciu"
          isDark={isDark}
          handleUpdateRegistration={handleUpdateRegistration}
          steps={stepsRegistration}
          activeStep={activeStep}
          colorScheme={colorScheme}
        />
      )}
    </PageContainer>
  )
}

export { OnboardingStepper }
